import { render, staticRenderFns } from "./CrudSelect.vue?vue&type=template&id=28fea44c"
import script from "./CrudSelect.vue?vue&type=script&lang=js"
export * from "./CrudSelect.vue?vue&type=script&lang=js"
import style0 from "./CrudSelect.vue?vue&type=style&index=0&id=28fea44c&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28fea44c')) {
      api.createRecord('28fea44c', component.options)
    } else {
      api.reload('28fea44c', component.options)
    }
    module.hot.accept("./CrudSelect.vue?vue&type=template&id=28fea44c", function () {
      api.rerender('28fea44c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/drc/components/crud-components/CrudSelect.vue"
export default component.exports